module.exports = __webpack_public_path__ + "img/classic_0.78052ea6.png";